import { Permit } from "../security/permit";
import { Node } from '../base/node';
import { Unit } from "./unit";
import { Branch } from "../base/branch";

export class Role extends Node {
    static _type: string = 'Role';

    i_role: true = true;

    permit: Permit = {};

    constructor(source?: any) {
        super(source);

        if (source) {
            this.permit = new Permit(source.permit);
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.permit = new Permit(source.permit);
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Unit;
    }
}
